<template>
  <main class="event-details" :class="{ 'event-details--expired': event.isExpired }">
    <div v-if="event.isExpired" class="event-details__expired-banner">
      <h3 class="text-h3 event-details__expired-text">
        {{ $t('resources.eventHasPassed') }}
      </h3>
    </div>
    <div ref="mainContent" class="event-details__content">
      <div v-if="event.img" class="event-details__img-wrapper">
        <img :src="event.img" :alt="event.imgAlt" />
      </div>
      <div class="event-details__copy-wrapper">
        <h2 class="text-h2 text-color-navy event-details__title" v-html="event.title" />
        <div
          v-if="event.subtitle || event.date"
          class="text-h4 text-color-navy event-details__date"
        >
          <span v-if="event.subtitle" v-html="event.subtitle" />
          <span v-if="event.subtitle && event.date" class="event-details__date-separator">|</span>
          <span v-if="event.date" v-html="getFullDate(event.date)" />
          <span v-if="event.additionalDate"> - </span>
          <span v-if="event.additionalDate" v-html="getFullDate(event.additionalDate)" />
        </div>
        <div class="event-details__description">
          <RichRenderer :richTextData="event.paragraph" />
        </div>
      </div>
    </div>
    <suggestions-carousel
      v-if="relatedProducts.length"
      class="event-details__carousel"
      :items="relatedProducts"
      :title="carouselTitle"
    />
  </main>
</template>
<script>
import { nextTick } from 'vue'

import { convertDateToItsZone } from '@/lib/utils/dates'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'
import SuggestionsCarousel from '@/components/common/SuggestionsCarousel.vue'

import { useTransformEntries } from '@/composables/useTransformEntries'
import { useBreadcrumbsStore } from '@/stores/breadcrumbs'

export default {
  name: 'EventDetails',
  components: {
    SuggestionsCarousel,
  },
  props: {
    activeEntry: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const breadcrumbsStore = useBreadcrumbsStore()
    const { getContentTypeId } = useContentfulComponent()
    const { transformEntries } = useTransformEntries()

    return {
      breadcrumbsStore,
      getContentTypeId,
      transformEntries,
    }
  },
  data() {
    return {
      event: {},
      relatedProducts: [],
      carouselTitle: 'Based on your activity, you may be interested in:',
    }
  },
  async mounted() {
    this.event = this.activeEntry
    this.breadcrumbsStore.setPathExtend([{ name: this.event.title }])
    this.relatedProducts = this.transformEntries(
      this.event.includes.filter((el) => this.getContentTypeId(el) === 'product'),
    )
    await nextTick()
    if (this.event.isExpired) this.hideExernalLinks()
  },
  methods: {
    getFullDate(date) {
      return convertDateToItsZone(date, 'LL')
    },
    hideExernalLinks() {
      const linksList = this.$refs.mainContent.querySelectorAll('a')
      linksList.forEach((linkNode) => {
        const isIncludesHttp = linkNode.href.includes('http')
        const isExternal = !linkNode.href.includes('bioivt.com')
        if (isIncludesHttp && isExternal) linkNode.style.display = 'none'
      })
    },
  },
}
</script>
